import { useToast } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Route, useHistory } from 'react-router-dom';

import { AssignmentRoute } from './AssignmentRoute';
import {
  errorToastConfig,
  warnToastConfig,
} from 'packages/common-frontend/constants';
import { useDataMetadataContext } from 'valleyBank/domains/page/hooks/DataMetadataContext';
import { useUserRoleTypePermissionsContext } from 'valleyBank/domains/page/hooks/useUserRoleTypePermissions';
import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';

export const AssignmentRouter = withLDConsumer()(() => {
  const { permissions } = useUserRoleTypePermissionsContext();
  const { dashboardMode } = useDataMetadataContext();
  const history = useHistory();
  const toast = useToast();

  if (dashboardMode !== 'current') {
    toast({
      ...warnToastConfig,
      id: 'assignment-only-current-mode',
      title: 'Assignment only availble in "current" mode.',
    });
    history.push('/');
  }

  if (!permissions.assignmentQueueRead) {
    toast({
      ...errorToastConfig,
      id: 'unauthorized-assignment-rate',
      title: 'Your user role does not allow access to Assignments',
    });
    history.push('/');
  }

  return (
    <ValleyBankTemplate>
      <Route exact path="/assignment" component={AssignmentRoute} />
    </ValleyBankTemplate>
  );
});
